import type { IFormControl } from "@/types"
import { cloneElement } from "react"
import { Controller, useFormContext, type FieldValues } from "react-hook-form"

interface CommonControlElementProps {
  error?: string
  name?: string
  value?: unknown
  onChange?: (value: unknown) => void
  label?: string
}

interface FormControlProps<T extends FieldValues> extends Omit<IFormControl<T>, "control"> {
  children: React.ReactElement<CommonControlElementProps>
  label?: string
}
export const FormControl = <T extends FieldValues>(props: FormControlProps<T>) => {
  const context = useFormContext<T>()
  if (context == null) return props.children
  const { control } = context
  return (
    <Controller
      {...props}
      control={control}
      rules={{ required: { value: props.required ?? false, message: "This field is required" }, ...props.rules }}
      render={({ field, fieldState: { error } }) =>
        cloneElement<CommonControlElementProps>(props.children, {
          error: error?.message,
          value: field.value,
          onChange: field.onChange,
          name: field.name,
        })
      }
    />
  )
}
